<template>
  <div class="pt-3">
    <div class="container-fluid">
      <b-card class="p-3">
        <div class="col-12 col-xl-7">
          <!-- Account Details ::Start -->
          <template v-for="(i, index) in formFields.filter((x) => x.type == 1)">
            <div 
              class="text-left"
              :key="index"
              :class="i.model == 'publicHybrid' ? 'd-none' : ''"
              >
              <b-row no-gutters class="align-items-center pb-3">
                <b-col
                  cols="3"
                  class="text-capitalize text-left font-size-base"
                >
                  {{ $t(`label.${i.title}`) }}
                  <span class="text-danger pl-1">*</span></b-col
                >
                <b-col cols="5" class="">
                  <div v-if="i.model == 'publicHybrid'">
                    <b-form-input
                      class="form-control"
                      value="VPN Connected"
                      disabled
                    ></b-form-input>
                    <AppFormField
                      v-model="$v.devOpsInfoObj[i.model].$model"
                      :state="validateObjState('devOpsInfoObj', i.model)"
                      :validators="i.validators"
                      :validationParams="i.validationParams"
                      :validationValue="$v.devOpsInfoObj[i.model]"
                      :formType="i.formType"
                      :options="i.options"
                      :disabled="i.disabled"
                      @change="i.action"
                      @keyup="i.action"
                      horizontal
                      hidden
                    >
                    </AppFormField>
                  </div>
                  <AppFormField
                    v-else
                    v-model="$v.devOpsInfoObj[i.model].$model"
                    :state="validateObjState('devOpsInfoObj', i.model)"
                    :validators="i.validators"
                    :validationParams="i.validationParams"
                    :validationValue="$v.devOpsInfoObj[i.model]"
                    :formType="i.formType"
                    :options="i.options"
                    :disabled="i.disabled"
                    @change="i.action"
                    @keyup="i.action"
                    horizontal
                  >
                  </AppFormField>
                  <div v-if="i.model == 'accountName'">
                    <div
                      v-if="isExistingName"
                      class="invalid-feedback invalid-feedback-msg"
                      :data-text="$t('label.existingAccountName')"
                      :class="[{ 'd-block': isExistingName }]"
                    >
                      {{ $t("label.existingAccountName") }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </template>
          <!-- Account Details ::End -->

          <!-- Account Network Details ::Start -->
          <template>
            <hr
              class="hr-text text-right pr-5 text-capitalize font-size-xl"
              :data-content="$t('label.network')"
            />
            <div class="pb-5">
              <!-- Region -->
              <template
                v-for="(i, index) in formFields.filter((x) => x.type == 2)"
              >
                <b-row
                  v-if="i.model == 'region'"
                  :key="index"
                  no-gutters
                  class="align-items-center pb-5"
                >
                  <b-col
                    cols="3"
                    class="text-capitalize text-left font-size-base"
                  >
                    {{ $t(`label.${i.title}`)
                    }}<span class="text-danger pl-1">*</span></b-col
                  >
                  <b-col cols="9" class="">
                    <AppFormField
                      v-model="$v.networkObj[i.model].$model"
                      :state="validateObjState('networkObj', i.model)"
                      :validators="i.validators"
                      :validationParams="i.validationParams"
                      :validationValue="$v.networkObj[i.model]"
                      :formType="i.formType"
                      :options="i.options"
                      :config="{
                        buttons: true,
                      }"
                      size="sm"
                      @change="i.action"
                      horizontal
                    >
                    </AppFormField>
                  </b-col>
                </b-row>
              </template>
              <!-- Table -->
              <div>
                <table class="table table-bordered table-fix m-0">
                  <thead>
                    <tr class="">
                      <th class="text-center font-size-base">
                        {{ $t("label.name") }}
                      </th>
                      <th class="text-center font-size-base">
                        {{ $t("label.availability") }}
                      </th>
                      <th class="text-center font-size-base">
                        {{ $t("label.IPv4") }}
                      </th>
                      <th class="text-center font-size-base text-nowrap">
                        {{ $t("label.action") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(i, index) in networkObj.subnet"
                      :key="index"
                      class=""
                    >
                      <td hidden>
                        {{ (i.no = index) }}
                      </td>
                      <td class="col-6">
                        <b-input
                          v-model="i.name"
                          type="text"
                          class="form-control"
                          :disabled="index < 2"
                          @keyup="validationCheckSubnet()"
                        ></b-input>
                      </td>
                      <td class="col-2 text-center">
                        <b-select
                          v-if="getAvailabilityZone(i.name).length > 0"
                          v-model="i.availability"
                          class="form-control"
                          :options="getAvailabilityZone(i.name)"
                          @change="validationCheckSubnet()"
                        >
                        </b-select>
                        <b-spinner
                          v-else
                          variant="primary"
                          type="grow"
                          label="Spinning"
                          small
                        ></b-spinner>
                      </td>
                      <td class="col-4">
                        <b-row class="align-items-center" no-gutters>
                          <b-input
                            v-model="i.iPv4"
                            type="text"
                            class="form-control col-7 px-2"
                            placeholder="0.0.0.0"
                            @keyup="
                              ValidateIPaddress($event.target.value);
                              validationCheckSubnet();
                            "
                          />
                          <span class="text-center col-1 px-2">/</span>
                          <b-select
                            v-model="i.iPv4a"
                            class="form-control col-3 px-2"
                            @change="validationCheckSubnet()"
                          >
                            <template v-for="i in 30">
                              <option
                                v-if="i >= 20 && index > 3"
                                :key="i"
                                :value="i"
                              >
                                {{ i }}
                              </option>
                            </template>
                            <template v-for="i in 29">
                              <option
                                v-if="i >= 27 && index <= 3"
                                :key="i"
                                :value="i"
                              >
                                {{ i }}
                              </option>
                            </template>
                          </b-select>
                        </b-row>
                        <div
                          v-if="ValidateIPaddress(i.iPv4)"
                          class="invalid-feedback invalid-feedback-msg"
                          :data-text="$t('label.invalidIPAddress')"
                          :class="[{ 'd-block': ValidateIPaddress(i.iPv4) }]"
                        >
                          {{ $t("label.invalidIPAddress") }}
                        </div>
                      </td>
                      <td
                        class="d-flex justify-content-center text-center p-0 col-2"
                      >
                        <div
                          :style="`opacity: ${index > 1 ? '1' : '0'};`"
                          :disabled="index < 2"
                          @click="deleteTableNetwork(index)"
                          class="p-0"
                        >
                          <i
                            class="far fa-trash-alt text-red font-size-sm cursor-pointer"
                          ></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <span class="text-small">{{
                  $t("message.specificAvailabilityZone")
                }}</span>
              </div>
              <div
                v-if="subnetErrorMeg"
                class="d-block invalid-feedback invalid-feedback-msg"
                :data-text="$t('fieldErrorMessage.requiredFieldDefault')"
              >
                {{ $t("fieldErrorMessage.requiredFieldDefault") }}
              </div>
              <button
                @click="addTableNetwork()"
                class="btn btn-primary btn-fill float-right my-2"
              >
                <i class="fa-solid fa-plus font-size-base"></i>
                {{ $t("label.add") }}
              </button>
            </div>
          </template>
          <!-- Account Network Details ::End -->

          <!-- Account Tag Details ::Start -->
          <template>
            <hr
              class="hr-text text-right my-10 pr-5 text-capitalize font-size-xl"
              :data-content="$t('label.tag')"
            />
            <template v-for="i in formFields.filter((x) => x.type == 3)">
              <div class="text-left" :key="i.name">
                <b-row no-gutters class="align-items-center pb-3">
                  <b-col
                    cols="3"
                    class="text-capitalize text-left font-size-base"
                  >
                    {{ $t(`label.${i.title}`)
                    }}<span class="text-danger pl-1">*</span></b-col
                  >
                  <b-col cols="5" class="">
                    <AppFormField
                      v-model="$v.devOpsTagObj[i.model].$model"
                      :state="validateObjState('devOpsTagObj', i.model)"
                      :validators="i.validators"
                      :validationParams="i.validationParams"
                      :validationValue="$v.devOpsTagObj[i.model]"
                      :formType="i.formType"
                      :options="i.options"
                      horizontal
                    >
                    </AppFormField>
                  </b-col>
                </b-row>
              </div>
            </template>
            <!-- Account Tag Details ::End -->
          </template>
          <!-- Account Tag Details ::End -->

          <!-- Action Button ::Start -->
          <hr />
          <button
            class="btn btn-success btn-fill float-right"
            @click="submitDevOpsCreateAccount"
          >
            {{ $t("label.submit") }}
          </button>
          <!-- Action Button ::End -->
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import AppFormField from "@/views/components/bases/form-field/AppFormField.vue";
import commonMixin from "@/core/mixins/common.mixin";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { i18nHelper } from "@/core/utils";
import { ROUTE_NAME } from "@/core/constants";
import { NETWORK_AVAILABILITY } from "@/core/constants/enums";
import { listApiService } from "@/core/services";
import {
  DEV_OPS_GET_ACCOUNT_NAME,
  DEV_OPS_CREATE_ACCOUNT,
  DEV_OPS_INITIAL_GET_ACCOUNT_NAME_STATE,
  DEV_OPS_INITIAL_CREATE_ACCOUNT_STATE,
} from "@/core/store/dev-ops.module";

export default {
  name: "CreateAccount",
  mixins: [commonMixin, validationMixin],
  components: {
    AppFormField,
  },
  data: () => ({
    formFields: [],
    existingAccount: [],
    availabilityZone: null,
    isExistingName: false,
    isInvalidIp: false,
    subnetErrorMeg: false,
    devOpsInfoObj: {
      publicHybrid: null,
      businessUnit: null,
      appName: null,
      environment: "",
      accountName: "HNK",
    },
    networkObj: {
      region: null,
      regionShortName: null,
      subnet: [
        {
          no: null,
          name: "CEN",
          availability: null,
          iPv4: "",
          iPv4a: 27,
        },
        {
          no: null,
          name: "CEN",
          availability: null,
          iPv4: "",
          iPv4a: 27,
        },
        {
          no: null,
          name: "ALB",
          availability: null,
          iPv4: "",
          iPv4a: 27,
        },
        {
          no: null,
          name: "ALB",
          availability: null,
          iPv4: "",
          iPv4a: 27,
        },
      ],
    },
    devOpsTagObj: {
      appOwner: null,
      costCenter: null,
      appFullName: null,
    },
  }),
  mounted() {
    this.initialDevOpsCreateAccount();
  },
  computed: {
    getDevOpsAccountNameComplate() {
      return this.$store.state.devOps.accountName.complete;
    },
    createDevOpsAccountComplate() {
      return this.$store.state.devOps.createAccount.complete;
    },
  },
  watch: {
    getDevOpsAccountNameComplate() {
      let response = this.$store.state.devOps.accountName;
      if (response.complete) {
        this.existingAccount = response.data;
        this.devOpsComplateAction(response, "get");
      }
    },
    createDevOpsAccountComplate() {
      let response = this.$store.state.devOps.createAccount;
      if (response.complete) {
        this.devOpsComplateAction(response, "create");
      }
    },
  },
  methods: {
    getAvailabilityZone(region) {
      let zoneArray = [];
      let value = null;
      if (this.availabilityZone) {
        if (region) {
          value = [
            NETWORK_AVAILABILITY.CEN,
            NETWORK_AVAILABILITY.ALB,
            NETWORK_AVAILABILITY.ECS,
            NETWORK_AVAILABILITY.NLB,
            NETWORK_AVAILABILITY.CLB,
            NETWORK_AVAILABILITY.RDS_MYSQL,
            NETWORK_AVAILABILITY.RDS_POSTGRESQL,
            NETWORK_AVAILABILITY.RDS_SQLSERVER,
            NETWORK_AVAILABILITY.RDS_MARIADB,
          ].includes(region.toLowerCase())
            ? region.toLowerCase() + "_zone"
            : "vpc_zone";
        } else {
          value = "vpc_zone";
        }

        const filteredArray = this.availabilityZone.filter(
          (obj) => Object.keys(obj)[0] === value
        );

        function filterZoneArray(selectedAvailability) {
          return filteredArray[0][value].map((x) => ({
            value: x.availability_zone,
            text: `${x.availability_zone} ${
              selectedAvailability.includes(x.availability_zone)
                ? "(selected)"
                : ""
            }`,
            disabled: selectedAvailability.includes(x.availability_zone),
          }));
        }

        if (region) {
          let selectedAvailability;
          switch (region.toLowerCase()) {
            case NETWORK_AVAILABILITY.CEN:
              selectedAvailability = this.networkObj.subnet
                .filter(
                  (item) => item.name === NETWORK_AVAILABILITY.CEN.toUpperCase()
                )
                .map((x) => x.availability);
              zoneArray =
                filteredArray.length > 0
                  ? filterZoneArray(selectedAvailability)
                  : [];

              break;
            case NETWORK_AVAILABILITY.ALB:
              selectedAvailability = this.networkObj.subnet
                .filter(
                  (item) => item.name === NETWORK_AVAILABILITY.ALB.toUpperCase()
                )
                .map((x) => x.availability);
              zoneArray =
                filteredArray.length > 0
                  ? filterZoneArray(selectedAvailability)
                  : [];

              break;
            default:
              zoneArray =
                filteredArray.length > 0
                  ? filteredArray[0][value].map((x) => ({
                      value: x.availability_zone,
                      text: x.availability_zone,
                    }))
                  : [];
          }
        } else {
          zoneArray =
            filteredArray.length > 0
              ? filteredArray[0][value].map((x) => ({
                  value: x.availability_zone,
                  text: x.availability_zone,
                }))
              : [];
        }
      }
      return zoneArray;
    },
    devOpsComplateAction(response, actionType) {
      let title = i18nHelper.getMessage("label.devOps");
      let messages = response.message;
      let code = response.code;
      let buttons = [];
      switch (actionType) {
        case "get":
          this.initialGetDevOpsAccountName();
          break;
        case "create":
          this.initialCreateDevOpsAccount();
          break;
      }
      if (response.code == 200) {
        buttons.push(
          {
            text: i18nHelper.getMessage("label.viewArgo"),
            variant: "success",
            action: () => {
              this.closeLayoutAppModalInfo();
              switch (actionType) {
                case "create":
                  window.open(response.data, "_blank");
                  break;
              }
            },
          },
          {
            text: i18nHelper.getMessage("label.ok"),
            variant: "primary",
            action: () => {
              this.$router.push({ name: ROUTE_NAME.DEVOPS_ACCOUNT_LOGGER });
              this.closeLayoutAppModalInfo();
            },
          }
        );
      } else {
        buttons.push({
          text: i18nHelper.getMessage("label.ok"),
          variant: "primary",
          action: () => {
            this.closeLayoutAppModalInfo();
          },
        });
      }
      if (messages) this.openLayoutAppModalInfo(title, messages, buttons, code);
    },
    addTableNetwork() {
      this.networkObj.subnet.push({
        no: null,
        name: null,
        availability: null,
        IPv4: null,
        IPv4a: null,
      });
    },
    deleteTableNetwork(index) {
      this.networkObj.subnet = this.networkObj.subnet.filter(
        (x) => x.no != index
      );
      this.validationCheckSubnet();
    },
    async setAccountName() {
      await this.getDevOpsAccountName(), 3000;

      this.isExistingName = false;

      this.devOpsInfoObj.accountName = null;
      let devOpsInfoObj = this.devOpsInfoObj;
      let businessUnit = "";
      let appName = devOpsInfoObj.appName
        ? devOpsInfoObj.appName.toUpperCase()
        : "";

      let environment = "";
      if (devOpsInfoObj.businessUnit) {
        businessUnit = devOpsInfoObj.businessUnit.name
          .substring(0, 1)
          .toUpperCase();
      }
      if (devOpsInfoObj.environment) {
        environment = devOpsInfoObj.environment.toUpperCase();
      }

      this.devOpsInfoObj.accountName =
        "HNK" + businessUnit + appName + environment;
      if (this.existingAccount.includes(this.devOpsInfoObj.accountName)) {
        this.isExistingName = true;
      }
    },
    async publicHybridList() {
      await listApiService.getPublicHybrid("").then(async (res) => {
        this.formFields.find((x) => x.model == "publicHybrid").options =
          await res.filter((x) => x.text == "VPN_Connected-Hybrid");

        this.devOpsInfoObj.publicHybrid = {
          name: this.formFields.find((x) => x.model == "publicHybrid")
            .options[0].value.name,
          value: this.formFields.find((x) => x.model == "publicHybrid")
            .options[0].value.value,
        };

        this.businessUnitList();
      });
    },
    businessUnitList() {
      let folderId = "";
      if (this.devOpsInfoObj.publicHybrid) {
        folderId = this.devOpsInfoObj.publicHybrid.value;
        listApiService
          .getPublicHybrid({
            folderId: folderId,
          })
          .then((res) => {
            if (res.length) {
              this.formFields.find((x) => x.model == "businessUnit").options =
                res;
              this.formFields.find(
                (x) => x.model == "businessUnit"
              ).disabled = false;
            }
          });
      }
    },
    initFormFields() {
      this.formFields = [
        {
          type: 1,
          model: "publicHybrid",
          title: "publicHybrid",
          formType: "select",
          options: [],
          disabled: true,
          validators: ["required"],
          action: (val) => {},
        },
        {
          type: 1,
          model: "businessUnit",
          title: "businessUnit",
          formType: "select",
          options: [],
          disabled: !this.devOpsInfoObj.publicHybrid,
          validators: ["required"],
          action: (val) => {
            this.setAccountName();
          },
        },
        {
          type: 1,
          model: "appName",
          title: "appName",
          validators: ["required"],
          action: (val) => {
            this.setAccountName();
          },
        },
        {
          type: 1,
          model: "environment",
          title: "environment",
          formType: "radios",
          options: [
            { text: "Dev", value: "dev" },
            { text: "UAT", value: "uat" },
            { text: "Prd", value: "prd" },
          ],
          validators: ["required"],
          action: () => {
            this.setAccountName();
          },
        },
        {
          type: 1,
          model: "accountName",
          title: "accountName",
          validators: ["required", "sameAs"],
          disabled: true,
          action: () => {},
        },
        {
          type: 2,
          model: "region",
          title: "region",
          formType: "radios",
          validators: ["required"],
          options: [
            { text: "ShangHai", value: "cn-shanghai", shortname: "sha" },
            { text: "HangZhou", value: "cn-hangzhou", shortname: "hgh" },
            { text: "ShenZhen", value: "cn-shenzhen", shortname: "szx" },
            { text: "HongKong", value: "cn-hongkong", shortname: "hkg" },
          ],
          action: (value) => {
            this.availabilityZone = listApiService.getAvailabilityZone(value);
            this.networkObj.regionShortName = this.formFields
              .find((x) => x.model == "region")
              .options.find((option) => option.value == value).shortname;
          },
        },
        {
          type: 3,
          model: "appOwner",
          title: "appOwner",
          validators: ["required"],
          action: () => {},
        },
        {
          type: 3,
          model: "costCenter",
          title: "costCenter",
          validators: ["required"],
          action: () => {},
        },
        {
          type: 3,
          model: "appFullName",
          title: "appFullName",
          validators: ["required"],
          action: () => {},
        },
      ];
    },
    validationCheckSubnet() {
      const allHaveValue = this.networkObj.subnet.every(
        (obj) =>
          obj.name != "" &&
          obj.iPv4 != "" &&
          obj.iPv4a != "" &&
          obj.name != null &&
          obj.iPv4 != null &&
          obj.iPv4a != null &&
          obj.availability != null
      );

      !allHaveValue
        ? (this.subnetErrorMeg = true)
        : (this.subnetErrorMeg = false);

      return allHaveValue;
    },
    submitDevOpsCreateAccount() {
      this.validationCheck("devOpsInfoObj");
      this.validationCheck("devOpsTagObj");
      this.validationCheck("networkObj");
      this.validationCheckSubnet();
      if (
        this.validationCheck("devOpsInfoObj") &&
        this.validationCheck("devOpsTagObj") &&
        this.validationCheck("networkObj") &&
        this.validationCheckSubnet() &&
        !this.isExistingName &&
        !this.isInvalidIp
      ) {
        let data = {
          ...this.devOpsInfoObj,
          ...this.networkObj,
          ...this.devOpsTagObj,
        };
        this.createDevOpsAccount(data);
      }
    },
    initialDevOpsCreateAccount() {
      let breadcrumbData = {
        breadcrumbs: [
          {
            title: i18nHelper.getMessage("label.devOps"),
            route: { name: ROUTE_NAME.DEVOPS_CREATE_ACCOUNT },
          },
          {
            title: i18nHelper.getMessage("label.createAccount"),
            route: { name: ROUTE_NAME.DEVOPS_CREATE_ACCOUNT },
          },
        ],
      };
      this.initBreadCrumb(breadcrumbData);
      this.initFormFields();
      this.publicHybridList();
    },
    getDevOpsAccountName() {
      this.$store.dispatch(DEV_OPS_GET_ACCOUNT_NAME, {});
    },
    createDevOpsAccount(data) {
      this.$store.dispatch(DEV_OPS_CREATE_ACCOUNT, { data });
    },
    initialGetDevOpsAccountName() {
      this.$store.dispatch(DEV_OPS_INITIAL_GET_ACCOUNT_NAME_STATE, {});
    },
    initialCreateDevOpsAccount() {
      this.$store.dispatch(DEV_OPS_INITIAL_CREATE_ACCOUNT_STATE, {});
    },
    ValidateIPaddress(val) {
      var ipformat =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if (val) {
        if (val.match(ipformat)) {
          this.isInvalidIp = false;
          return false;
        } else {
          this.isInvalidIp = true;
          return true;
        }
      }
    },
  },
  validations() {
    return {
      devOpsInfoObj: {
        publicHybrid: { required },
        businessUnit: { required },
        appName: { required },
        environment: { required },
        accountName: { required },
      },
      networkObj: {
        region: { required },
      },
      devOpsTagObj: {
        appOwner: { required },
        costCenter: { required },
        appFullName: { required },
      },
    };
  },
};
</script>

<style></style>
